"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _expander = _interopRequireDefault(require("../expander"));
var _excluded = ["initiallyExpanded", "renderToggle"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * A simplified interface for the `Expander` component. Renders a `toggle` element and `Expander`
 * containing passed in children. `SimpleExpander` toggles the expanded state when the `toggle` is
 * clicked, and handles ARIA attributes appropriately.
 *
 * All props applied to the component are passed down to the underlying `Expander`, allowing for
 * usage of that component's prop API.
 *
 * `SimpleExpander` includes three methods to change the current expanded state of the component.
 * If you need to programmatically change the expanded state, assign the `SimpleExpander` to a ref
 * and call these methods from the parent component.
 *
 * - `openExpander()`
 * - `closeExpander()`
 * - `toggleExpander()`
 */
var SimpleExpander = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function SimpleExpander(props) {
    var _this;
    _classCallCheck(this, SimpleExpander);
    _this = _callSuper(this, SimpleExpander, [props]);
    _this.state = {
      isExpanded: props.initiallyExpanded,
      expanderId: null
    };
    _this.toggleExpander = _this.toggleExpander.bind(_this);
    return _this;
  }

  // eslint-disable-next-line camelcase
  _inherits(SimpleExpander, _React$Component);
  return _createClass(SimpleExpander, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.setState({
        expanderId: (0, _uniqueId2["default"])('simpleExpander')
      });
    }
  }, {
    key: "openExpander",
    value: function openExpander() {
      this.setState({
        isExpanded: true
      });
    }
  }, {
    key: "closeExpander",
    value: function closeExpander() {
      this.setState({
        isExpanded: false
      });
    }
  }, {
    key: "toggleExpander",
    value: function toggleExpander() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: "renderToggle",
    value: function renderToggle() {
      var isExpanded = this.state.isExpanded;
      var toggle = this.props.renderToggle(isExpanded);
      return /*#__PURE__*/_react["default"].cloneElement(toggle, {
        'aria-expanded': isExpanded,
        'aria-controls': isExpanded ? this.state.expanderId : null,
        onClick: this.toggleExpander
      });
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
        initiallyExpanded = _this$props.initiallyExpanded,
        renderToggle = _this$props.renderToggle,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("div", null, this.renderToggle(), /*#__PURE__*/_react["default"].createElement(_expander["default"], _extends({
        id: this.state.expanderId,
        isExpanded: this.state.isExpanded
      }, otherProps)));
    }
  }]);
}(_react["default"].Component);
SimpleExpander.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  /**
   * The expanded state of the component when it is initially rendered.
   */
  initiallyExpanded: _propTypes["default"].bool,
  /**
   * A callback to render a toggle element. Receives the current `isExpanded` state of the
   * component as a parameter.
   */
  renderToggle: _propTypes["default"].func.isRequired
} : {};
SimpleExpander.defaultProps = {
  initiallyExpanded: false
};